import { Theme, makeStyles } from "@remo-co/ui-core";

export const useStyles = makeStyles<Theme>(() => ({
  avatar: {
    left: "-1rem",
    marginLeft: 12,
  },
}));
